import axios from 'axios';
import authService from './authService';

const API_URL = process.env.REACT_APP_API_URL;

const getAuthHeaders = () => ({ Authorization: `Bearer ${authService.getToken()}` });

const getTemplates = () =>
    axios.get(`${API_URL}/api/labels/templates`, { headers: getAuthHeaders() }).then(r => r.data);

const createTemplate = (data) =>
    axios.post(`${API_URL}/api/labels/templates`, data, { headers: getAuthHeaders() }).then(r => r.data);

const updateTemplate = (id, data) =>
    axios.patch(`${API_URL}/api/labels/templates/${id}`, data, { headers: getAuthHeaders() }).then(r => r.data);

const deleteTemplate = (id) =>
    axios.delete(`${API_URL}/api/labels/templates/${id}`, { headers: getAuthHeaders() }).then(r => r.data);

const getLotCodeDates = (lotCodes) =>
    axios.post(`${API_URL}/api/labels/lot-code-dates`, { lotCodes }, { headers: getAuthHeaders() }).then(r => r.data);

const getImageAsBase64 = (url) =>
    axios.get(`${API_URL}/api/labels/image-proxy`, { params: { url }, headers: getAuthHeaders() }).then(r => r.data.base64);

const labelService = { getTemplates, createTemplate, updateTemplate, deleteTemplate, getLotCodeDates, getImageAsBase64 };
export default labelService;
